import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Sapscmtemplate extends Component {
 
  render() {
    const course =[
        {
          title :  "Introduction to SAP SCM",
        content: [
        "Overview of Supply Chain Management",
        "Introduction to SAP SCM and its components",
        "SAP SCM Architecture and Integration with other SAP Modules"
        ]
        },
          {
          title :  "Demand Planning",
        content: [
        "Introduction to Demand Planning",
        "Planning Object Structure (POS)",
        "Time Bucket Profiles and Planning Buckets",
        "Demand Management Planning Strategies",
        "Forecasting Techniques and Models",
        "Lifecycle Planning and Promotion Planning"
        ]
        },
          {
          title :  "Supply Network Planning (SNP)",
        content: [
        "Overview of Supply Network Planning",
        "SNP Planning Areas and Planning Books",
        "Supply Chain Model and Master Data in SNP",
        "SNP Heuristic Run and Capacity Check",
        "SNP Deployment and Transport Load Builder"
        ]
        },
          {
          title :  "Core Interface (CIF)",
        content: [
        "Introduction to Core Interface (CIF)",
        "Integration Model Generation and Activation",
        "Transfer of Master Data and Transaction Data",
        "Monitoring and Error Handling in CIF"
        ]
        },
          {
          title :  "Production Planning and Detailed Scheduling (PP/DS)",
        content: [
        "Introduction to PP/DS",
        "PP/DS Planning Board and Planning Table",
        "Master Data in PP/DS",
        "PP/DS Heuristic Run and Scheduling",
        "Capacity Evaluation and Scheduling with Capable-to-Match (CTM)"
        ]
        },
          {
          title :  "Global Available-to-Promise (Global ATP)",
        content: [
        "Overview of Global ATP",
        "Basic Settings and Master Data for Global ATP",
        "Rule-Based ATP and Product Allocations",
        "Backorder Processing and Product Substitution"
        ]
        },
          {
          title :  "Inventory Collaboration Hub (ICH)",
        content: [
        "Introduction to Inventory Collaboration Hub",
        "Collaboration Process and Configuration",
        "Monitoring and Error Handling in ICH"
        ]
        },
          {
          title :  "Advanced Planning and Optimization (APO)",
        content: [
        "Overview of SAP APO and its components",
        "Integration with SAP ECC and other Systems",
        "SAP APO Data Exchange and CIF"
        ]
        },
          {
          title :  "Supply Chain Cockpit",
        content: [
        "Introduction to Supply Chain Cockpit",
        "Key Performance Indicators (KPIs) and Dashboards",
        "Real-time Monitoring and Alerts"
        ]
        },
          {
          title :  "Integration with Other Modules",
        content: [
        "Integration with SAP MM (Materials Management)",
        "Integration with SAP SD (Sales and Distribution)",
        "Integration with SAP PP (Production Planning)",
        "Integration with SAP QM (Quality Management)"
        ]
        }
    ]

 
    const faqData = [
      {
        question: 'What is SAP SCM Training?',
        answer:
          'SAP SCM Training is a specialized program designed to equip individuals with the skills and knowledge needed to effectively utilize SAP\'s Supply Chain Management (SCM) software',
      },
      {
        question: 'Who can benefit from SAP SCM Training?',
        answer:
          'SAP SCM Training at the best training centre is suitable for supply chain professionals, logistics managers, business analysts, and anyone involved in supply chain operations who wishes to leverage SAP\'s SCM solutions',
      },
      {
        question: 'What topics are covered in SAP SCM Training at the best training centre?',
        answer:
          'SAP SCM Training at the best training centre covers a range of topics including demand planning, supply network planning, production planning, inventory management, logistics execution, and advanced analytics',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with SAP SCM skills can pursue career opportunities as an SAP SCM Consultant, Supply Chain Analyst, Demand Planner, Inventory Analyst, or Logistics Manager.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into SAP SCM at the Best Training Centre. Our comprehensive SAP SCM training program is designed to accommodate learners from various professional backgrounds, irrespective of prior experience in supply chain management or SAP systems. Whether you're a logistics professional, business analyst, or IT specialist looking to enhance your skills, our courses cater to individuals at every proficiency level. With a focus on practical application and real-world scenarios, our expert instructors guide you through essential SAP SCM concepts, including inventory management, demand planning, production scheduling, and logistics execution. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in mastering SAP SCM. Join us and unlock your potential in supply chain management with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ramcharan",
          date:" july 09 ,2023",
          review: `SAP SCM Training in ${this.props.location} is an excellent option for those looking to upskill and advance their careers in the field of SAP SCM. Learnsoft.org provides one of the Best SAP SCM Training in ${this.props.location} with a focus on both theoretical and practical learning. The course is designed to provide students with a comprehensive understanding of SAP SCM and its key components, including continuous integration and delivery, containerization, infrastructure as code, and automation.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Hariharan",
          date:" july 29 ,2023",
          review:"Another advantage of Learnsoft.org's SAP SCM Training with Certification is the use of hands-on exercises and projects. These projects provide students with the opportunity to apply what they have learned in a practical setting, allowing them to gain a deeper understanding of the concepts and tools covered in the course."
      },
  ]

    
    return(
      <>
        
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the intricate dance of modern commerce, an optimized supply chain is the linchpin of operational success. Enter SAP SCM, an abbreviation denoting SAP Supply Chain Management. It emerges as a comprehensive software solution provided by SAP, meticulously designed to streamline and optimize the end-to-end supply chain processes within organizations. SAP SCM serves as the compass guiding businesses to plan, execute, and monitor their supply chain operations with utmost efficiency."/> */}
        
          <NewMainsec rating='4.1' students={"323"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the intricate dance of modern commerce, an optimized supply chain is the linchpin of operational success. Enter SAP SCM, an abbreviation denoting SAP Supply Chain Management. It emerges as a comprehensive software solution provided by SAP, meticulously designed to streamline and optimize the end-to-end supply chain processes within organizations. SAP SCM serves as the compass guiding businesses to plan, execute, and monitor their supply chain operations with utmost efficiency."/>           

        
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		        <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`SAP Supply Chain Management (SCM) Training is a comprehensive course designed to provide participants with the knowledge and skills to effectively manage supply chain processes using the SAP SCM module. SAP SCM is a critical component of the SAP ERP system, dedicated to optimizing supply chain planning, logistics, and execution. This training aims to equip learners with the expertise to configure, customize, and streamline the SAP SCM module, ensuring efficient and responsive supply chain operations.`} 
            title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our SAP SCM (Supply Chain Management) course covers topics such as supply chain planning, inventory management, procurement, demand forecasting, production planning, and logistics execution. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in SAP SCM. By the end of the course, you will be able to implement SAP SCM practices in your own projects."}/>
		      </section>
          <Batchtime title={this.props.title} fees="39,999" offer="34,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
 <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
        <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="SAP BASIS" coupath2="sap-basis" cou='SAP FICO' coupath='sap-fico' cou9='SAP SD' coupath9='sap-sd' cou6='SAP MM' coupath6='sap-mm' cou10='SAP BI' coupath10='sap-bi'
          cou5='SAP MDG' coupath5='sap-mdg' cou3='SAP FIORI' coupath3='sap-fiori' cou7='SAP HR' coupath7='sap-hr'
          cou1='SAP ABAP' coupath1='sap-abap' cou8='SAP PP' coupath8='sap-pp'  cou4='SAP S4 HANA' coupath4='sap-s4-hana' />

        
      </>
    );
  }
}
